// The bottom sheet has a backdrop, a panel that slides up from the bottom, and a history
// entry so the back button closes it.

let open: (() => void) | null = null;
let content: HTMLElement | null = null;

export function openSheet(title: string, body: HTMLElement): void {
  closeSheet();

  const root = document.createElement("div");
  root.className = "sheet-root";

  const backdrop = document.createElement("div");
  backdrop.className = "sheet-backdrop";
  backdrop.addEventListener("click", () => history.back());

  const panel = document.createElement("div");
  panel.className = "sheet-panel";

  const header = document.createElement("header");
  const heading = document.createElement("h2");
  heading.textContent = title;
  const dismiss = document.createElement("button");
  dismiss.className = "sheet-dismiss";
  dismiss.setAttribute("aria-label", "Close");
  dismiss.textContent = "X";
  dismiss.addEventListener("click", () => history.back());
  header.append(heading, dismiss);

  const scroller = document.createElement("div");
  scroller.className = "sheet-content";
  scroller.append(body);
  content = scroller;

  panel.append(header, scroller);
  root.append(backdrop, panel);
  document.body.append(root);
  document.body.classList.add("sheet-is-open");

  const escape = (event: KeyboardEvent) => {
    if (event.key === "Escape") history.back();
  };
  document.addEventListener("keydown", escape);

  open = () => {
    document.removeEventListener("keydown", escape);
    document.body.classList.remove("sheet-is-open");
    root.remove();
    open = null;
    content = null;
  };

  history.pushState({ sheet: true }, "", location.href);
}

export function closeSheet(): void {
  open?.();
}

/** Redraw the open sheet in place. Reopening it would push a second history entry, and
 *  the back button would then need two taps to leave a sheet the player bought from. */
export function refreshSheet(body: HTMLElement): void {
  content?.replaceChildren(body);
}

export function sheetIsOpen(): boolean {
  return open !== null;
}
